import { SxProps, Theme, Typography } from '@mui/material'

type FormErrorType = {
  msg?: string
  sx?: SxProps<Theme> | undefined
}
export const FormError = ({ msg, sx }: FormErrorType) => {
  return <Typography sx={{ color: 'chileanFire.main', ...sx }}>{msg}</Typography>
}
